module.exports = __webpack_public_path__ + "img/error.2da9dde8.svg";